import { jsxs as r, jsx as a } from "react/jsx-runtime";
import { ProductCardImage as d } from "../ProductCardImage/index.js";
import { ProductCardName as l } from "../ProductCardName/index.js";
const s = ({
  image: o,
  name: c,
  variant: t
}) => t === "horizontal" ? /* @__PURE__ */ r(
  "div",
  {
    id: "product-card-unavailable",
    className: "product-card-horizontal-unavailable",
    children: [
      /* @__PURE__ */ a(
        "div",
        {
          className: "product-card-horizontal",
          style: {
            backgroundColor: "var(--color-grayScale-faded)"
          },
          children: /* @__PURE__ */ r("div", { className: "product-card-section-product-horizontal out-of-stock", children: [
            /* @__PURE__ */ a(d, { image: o }),
            /* @__PURE__ */ a(
              "div",
              {
                className: "product-card-horizontal-description out-of-stock",
                style: {
                  backgroundColor: "var(--color-grayScale-lightest)"
                },
                children: /* @__PURE__ */ a(l, { name: c })
              }
            )
          ] })
        }
      ),
      /* @__PURE__ */ a("div", { className: "product-card-unavailable-text", children: /* @__PURE__ */ a("p", { children: "Indisponível" }) })
    ]
  }
) : /* @__PURE__ */ r("div", { id: "product-card-unavailable", className: "out-of-stock", children: [
  /* @__PURE__ */ r("div", { className: "product-card out-of-stock", children: [
    /* @__PURE__ */ a(
      d,
      {
        image: {
          url: o.url,
          alternateName: o.alternateName
        },
        variant: "vertical"
      }
    ),
    /* @__PURE__ */ a("div", { className: "out-of-stock-description-content", children: /* @__PURE__ */ a(
      "div",
      {
        className: "product-card-description",
        style: {
          backgroundColor: "var(--color-grayScale-faded)",
          height: "160px"
        },
        children: /* @__PURE__ */ a(l, { name: c })
      }
    ) })
  ] }),
  /* @__PURE__ */ a("div", { className: "product-card-unavailable-text", children: /* @__PURE__ */ a("p", { children: "Indisponível" }) })
] });
export {
  s as ProductCardUnavailable
};
